const divModalFilterService = {
  cancel: 'CANCEL',
  ok: 'APPLY'
};

export default divModalFilterService;
